import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=9ca297ba&scoped=true"
import script from "./user-avatar.vue?vue&type=script&lang=js"
export * from "./user-avatar.vue?vue&type=script&lang=js"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=9ca297ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca297ba",
  null
  
)

export default component.exports